import {GenericoTipoEnum} from "../../bibliotecaPjus/enums/enumGenerico.enum";

export enum StatusProposta {
  EmAndamento = 'EmAndamento',
  Aprovada = 'Aprovada',
  Reprovada = 'Reprovada',
  Pago = 'Pago',
  AptoParaPagamento = 'AptoParaPagamento',
  PagoTribunal = 'PagoPeloTribunal'
}

export class StatusPropostaEnum extends GenericoTipoEnum<StatusProposta> {
  static readonly EmAndamento = new StatusPropostaEnum(StatusProposta.EmAndamento, 'Em Andamento');
  static readonly Aprovada = new StatusPropostaEnum(StatusProposta.Aprovada, 'Aprovada');
  static readonly Reprovada = new StatusPropostaEnum(StatusProposta.Reprovada, 'Reprovada');
  static readonly Pago = new StatusPropostaEnum(StatusProposta.Pago, 'Pago');
  static readonly PagoTribunal = new StatusPropostaEnum(StatusProposta.PagoTribunal, 'Pago tribunal');
  static readonly AptoParaPagamento = new StatusPropostaEnum(StatusProposta.AptoParaPagamento, 'Apto para pagamento');
}
